/**
 * 轻量化引擎相关
 */
import { mongeApp, mongeMutations } from "./store/mongeStore";
import { MessageBox, Message } from "element-ui";
const ExportJsonExcel = require("js-export-excel");
import Vue from "vue";
import Contextmenu from "vue-contextmenujs";
Vue.use(Contextmenu);
// 全局定义引擎api名称
let viewer3d;
let viewer2d; // 模型图纸
let domModel;
let zoomTool2D; // 框选放大
let measureTool2D; // 二维测量工具类
let measureManagerTool2D; // 二维测量管理工具类
let selectMapTool; // 二维构件管理工具
let penTool; // 二维画笔工具类
let panTool; // 二维图纸平移工具类
let scaleTool; // 二维图纸缩放工具工具类
let annotationTool; // 二维图纸批注工具类
let annotationManagerTool; // 二维图纸批注管理工具类
let zoomTool; // 框选放大工具类
let measureTool; // 测量工具类
let measureManagerTool; // 测量管理工具类
let sectionTool; // 三维剖切工具类
let selectTool; // 3D工具管理，此类不允许创建，可从viewer3D获取对象。
let miniMapTool; // 三维小地图工具类
let walkTool; // 行走漫游工具类
let menuTool; // 右键菜单工具类
let modelMap;
let mapModel; // 二三维联动
let markTool; // 三维锚点工具类
let markManagerTool; // 锚点管理工具类
let transformTool; //
let globeTool; // 三维地球工具类
let areaPlaneTool; // 三维面积平面工具类
let JoyStickTool; // 三维移动端虚拟摇杆
let space3DTool;
const $prompt = MessageBox.prompt;
const enginerelease = {
  // 启动新的模式， true 为启用
  isOssFile() {
    return mongeApp.mlibEnabled || false;
  },
  EngineResources() {
    Monge.EngineResources = "./EngineResources";
  },
  // 加载图纸
  async loadMap(url, dom, longforLoading) {
    document.getElementById(dom).innerHTML = "";
    viewer2d = new Monge.Viewer2D(dom, {
      longforLoading: longforLoading || false // 过度动画水平垂直居中
    });

    window.viewer2d = viewer2d;
    window.addEventListener("resize", () => {
      viewer2d.reSize();
    });
    await this.initMapAPI();
    await viewer2d.load(url, {
      isOssFile: this.isOssFile()
    });
  },
  // 初始化图纸api
  initMapAPI() {
    zoomTool2D = new Monge.Zoom2D(viewer2d);
    measureManagerTool2D = new Monge.MeasureManager2D(viewer2d);
    measureTool2D = new Monge.Measure2D(viewer2d);
    new Monge.Calibration2D(viewer2d);
    selectMapTool = viewer2d.toolsManager.getToolsByName(Monge.ToolName.D_SELECTOR);
    penTool = new Monge.Pencil2D(viewer2d);
    panTool = new Monge.PanDrawing(viewer2d);
    scaleTool = new Monge.ScaleDrawing(viewer2d);
    annotationTool = new Monge.Annotation(viewer2d);
    annotationManagerTool = new Monge.AnnotationManager(viewer2d);
    // 批注云线双击事件
    annotationManagerTool.active({
      callback: (type, data) => {
        if (type === Monge.CallbackType.DBCLICK) {
          mongeMutations.openMapDetail(data);
        }
      }
    });
  },
  /**
   * 加载模型
   */
  async loadModel(url, dom, boolean) {
    domModel = document.getElementById(dom);
    viewer3d = new Monge.Viewer3D(dom, {
      effect:
        Monge.EffectType3D.Render |
        Monge.EffectType3D.Sky |
        Monge.EffectType3D.FouLine |
        Monge.EffectType3D.SSAO |
        Monge.EffectType3D.FXAA |
        0,
      // isDefaultUI: true, // 是否使用默认UI
      longforLoading: boolean || false, // 过度动画水平垂直居中
      enableTools: {
        cube: !boolean
      }
    });
    window.viewer3d = viewer3d;
    window.addEventListener("resize", () => {
      viewer3d.reSize();
    });
    await this.initModelAPI();
    if (boolean) { // 手机端
    //   const box = viewer3d.cube.cubeBox;
    //   box.style.top = "46px";
    }
    await viewer3d.load(url, { isOssFile: this.isOssFile() });
  },
  async loadNoLightweight3D(url, dom, fileType, boolean) {
    domModel = document.getElementById(dom);
    viewer3d = new Monge.Viewer3D(dom, {
      effect:
        Monge.EffectType3D.Render |
        Monge.EffectType3D.Sky |
        Monge.EffectType3D.FouLine |
        Monge.EffectType3D.SSAO |
        Monge.EffectType3D.FXAA |
        0,
      // isDefaultUI: true,//是否使用默认UI
      longforLoading: boolean || false, // 过度动画水平垂直居中
      enableTools: {
        cube: !boolean
      }
    });
    window.viewer3d = viewer3d;
    window.addEventListener("resize", () => {
      viewer3d.reSize();
    });
    await this.initModelAPI();
    if (boolean) { // 手机端
      // const box = viewer3d.cube.cubeBox;
      // box.style.top = "46px";
    }
    if (Number(fileType) === 24) {
      await viewer3d.modelManager.loadFBX(url, { isOssFile: this.isOssFile() });
    } else if (Number(fileType) === 43) {
      await viewer3d.modelManager.loadObj(url, { isOssFile: this.isOssFile() });
    } else if (Number(fileType) === 44) {
      await viewer3d.modelManager.loadGltf(url, { isOssFile: this.isOssFile() });
    }
    viewer3d.cameraManager.fitToAllModels({
      duration: 0,
      complete: () => {
        // debugger;
        mongeMutations.openModelReady(true);
        mongeMutations.setIsNoLightweight(true);
      }
    });
  },
  // 模型api初始化
  initModelAPI() {
    zoomTool = new Monge.Zoom3D(viewer3d);
    measureTool = new Monge.Measure3D(viewer3d);
    measureManagerTool = new Monge.MeasureManager3D(viewer3d);
    sectionTool = new Monge.Section(viewer3d);
    selectTool = viewer3d.toolsManager.getToolsByName(Monge.ToolName.X_SELECTOR);
    miniMapTool = new Monge.MiniMap3D(viewer3d);
    walkTool = viewer3d.toolsManager.getToolsByName(Monge.ToolName.X_WALK);
    menuTool = viewer3d.toolsManager.getToolsByName(Monge.ToolName.X_CONTEXT_MENU); // 鼠标右键
    markTool = new Monge.Mark3D(viewer3d);
    markManagerTool = markTool.manager;
    transformTool = new Monge.TransformControl3D(viewer3d);
    areaPlaneTool = new Monge.AreaPlane(viewer3d);
    globeTool = new Monge.Globe(viewer3d);
    JoyStickTool = new Monge.JoyStick(viewer3d);
    space3DTool = new Monge.Space3D(viewer3d);
    menuTool.setCB((data) => {
      this.onContextmenu(data);
    });
    // 属性domModel
    domModel.addEventListener(Monge.EventType.select, (e) => {
      if (!e.data) {
        this.attrData = [];
        return;
      }
      mongeMutations.setModelProps(e.data.modelId, e.data.elementId);
    });
    domModel.addEventListener(Monge.EventType.hidden, (e) => {
      const data = e.data;
      const mgNodeId = this.getTreeNodeId(data.modelId, data.elementId);
      mongeMutations.addHiddenElementIdlist(mgNodeId);
    });
    domModel.addEventListener(Monge.EventType.showAll, (e) => {
      mongeMutations.clearHiddenElementIdlist();
    });
    domModel.addEventListener(Monge.EventType.attributeDone, (e) => {
      mongeMutations.openModelReady(true);
    });
    // 剖切工具中用到拾取面工具，提前注册
    new Monge.PickFace(viewer3d);
  },
  // 鼠标右键属性
  onContextmenu(data) {
    if (!data || !data.funcList || data.funcList.length === 0) return;
    const array = [];
    data.funcList?.forEach((e) => {
      array.push({
        label: e.description,
        value: e.value,
        onClick: () => {
          this.rightMouseClick(e.value, data.componentAttr);
        }
      });
    });
    Vue.prototype.$contextmenu({
      items: array,
      x: data.x,
      y: data.y,
      zIndex: 3,
      minWidth: 230
    });
    return false;
  },
  rightMouseClick(funcType, componentAttr) {
    const FuncType = Monge.MenuFuncType3D;
    switch (funcType) {
      case FuncType.CANCEL_SELECT.value:
        selectTool.cancelSelect();
        break;
      case FuncType.SELECT_CAT.value:
        selectTool.selectCat();
        break;
      case FuncType.FLY_TO.value:
        selectTool.fitTo();
        break;
      case FuncType.HIDE.value:
        selectTool.hideSelection();
        break;
      case FuncType.HIDE_OTHER.value:
        selectTool.hideOther();
        break;
      case FuncType.SHEER.value:
        selectTool.sheerSelection();
        break;
      case FuncType.CANCEL_SHEER.value:
        viewer3d.cancelSheer();
        break;
      case FuncType.SHOW_ALL.value:
        viewer3d.showAll();
        break;
    }
  },
  /**
 * @description: 模型图纸，做联动
 * @param {url} 图纸url
 * @param {id}  图纸dom元素
 * @param {longforLoading} 加载图位置是否水平垂直
 * @param {modelFileId} 模型id
 */
  async loadModelMap(params) {
    const { url, id, longforLoading, modelFileId, rvtVersion, modelId } = params;
    viewer2d?.dispose();
    viewer2d = new Monge.Viewer2D(id, {
      longforLoading: longforLoading || false
    });
    window.viewer2d = viewer2d;
    window.addEventListener("resize", () => {
      viewer2d.reSize();
    });
    viewer3d.reSize();
    this.initMapAPI();
    await viewer2d.load(url, { isOssFile: this.isOssFile() });
    if (this.isOssFile()) {
      this.initMapping(modelId);
      this.addEventListener(modelId);
    } else {
      this.initMapping(modelFileId, rvtVersion);
      this.addEventListener(modelFileId, rvtVersion);
    }
  },
  initMapping(modelFileId, rvtVersion) {
    let model;
    if (this.isOssFile()) {
      model = viewer3d.models.find((e) => e.id === modelFileId);
    } else {
      const url = mongeApp.model.urlFileIdList?.find((e) => e.fileId === modelFileId && e.rvtVersion === rvtVersion).url;
      model = viewer3d.models.find((e) => e.url === url);
    }
    const modelElementIds = [];
    const mapElementIds = viewer2d.map.id2ElementId;
    modelMap = []; // 模型图纸映射
    mapModel = []; // 图纸模型映射
    const attrManager = model.attrManager;
    const rootId = attrManager.rootId;
    model.elementLeafIterator(rootId, (modelElementId) => {
      const attributes = attrManager.getItemAttributes(modelElementId); // 获取构件属性
      const attr = attributes.find((a) => a.name === "#elementId"); // 获取elementId属性
      modelElementIds.push(attr.value);
      if (attr) {
        const idx = mapElementIds.findIndex((eId) => eId === attr.value); // 模型与图纸id匹配
        if (idx > -1) { //  添加映射关系
          modelMap[modelElementId] = idx;
          mapModel[idx] = modelElementId;
        }
      }
    });
  },
  addEventListener(modelFileId, rvtVersion) {
    let model;
    if (this.isOssFile()) {
      model = viewer3d.models.find((e) => e.id === modelFileId);
    } else {
      const url = mongeApp.model.urlFileIdList?.find((e) => e.fileId === modelFileId && e.rvtVersion === rvtVersion).url;
      model = viewer3d.models.find((e) => e.url === url);
    }
    const selectTool2D = viewer2d.toolsManager.getToolsByName(Monge.ToolName.D_SELECTOR);
    const selectTool3D = viewer3d.toolsManager.getToolsByName(Monge.ToolName.X_SELECTOR);
    domModel.addEventListener(Monge.EventType.componentClicked, (e) => {
      if (!e || !e.data) {
        selectTool2D.linkSelect(null);
        return;
      }
      const elementId = e.data.elementId;
      const mapElementId = modelMap[elementId];
      if (mapElementId) selectTool2D.linkSelect(mapElementId);
    });
    selectTool2D.addSelectionEvent((e) => {
      if (!e) {
        selectTool3D.linkSelect(model.id, null);
        viewer3d.cameraManager.goHome();
        return;
      }
      const elementId = e.elementId;
      const modelElementId = mapModel[elementId];
      if (modelElementId) {
        selectTool3D.linkSelect(model.id, modelElementId);
        selectTool3D.fitTo();
      }
    });
  },
  closeMap() {
    viewer2d.dispose();
    viewer3d.reSize();
  },
  resize() {
    viewer3d?.reSize();
    viewer2d?.reSize();
  },
  mapFitToAll() {
    return viewer2d.cameraManager.fit2Element({});
  },
  // 图纸背景色 0xff0000或者"#ff0000"
  set2DBgc(val) {
    viewer2d.setBackground(val);
  },
  // 图纸选框放大
  zoom2D(switchBoolean) {
    return new Promise((reslove) => {
      zoomTool2D.active({
        continuous: false,
        callback: (type) => {
          if (type === Monge.CallbackType.DONE) reslove(!switchBoolean);
        }
      });
    });
  },
  /**
   * @description: 图纸测量
   * @param {ToolBase} 测量类型
   * @param {unit} 测量单位
   * @param {continuous} 是否连续测量
   * @param {switchBoolean} 回调
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  measure2D(ToolBase, unit, continuous, switchBoolean) {
    measureManagerTool2D.setUnit(unit || Monge.Unit.MM);
    return new Promise((reslove) => {
      measureTool2D.active({
        mode: ToolBase,
        continuous,
        callback: (type) => {
          if (type === Monge.CallbackType.DONE) reslove(!switchBoolean);
        }
      });
    });
  },
  /**
   * @description: 图纸测量H5
   * @param {ToolBase} 测量类型
   * @param {call} 回调
   */
  measureH52D(ToolBase, call) {
    measureManagerTool2D.setUnit(Monge.Unit.MM);
    measureTool2D.active({
      mode: ToolBase,
      continuous: false,
      callback: (type, data) => {
        call.callback(type, data);
      }
    });
  },
  // 关闭测量
  deactiveMapMeasure() {
    measureTool2D.deactive();
  },
  // 清除图纸测量
  clearMapMeasure() {
    measureManagerTool2D.clear();
  },
  // 结束当前面积测量
  measureH5closeArea() {
    measureTool2D.closeArea();
  },
  // 清除画笔
  clearPencil() {
    penTool.manager.clear();
  },
  // 显示所有绘制内容
  showPencilAll() {
    penTool.manager.showAll();
  },
  // 隐藏所有绘制内容
  hiddenPencilAll() {
    penTool.manager.hideAll();
  },
  // 删除选中的画笔
  pencilRemoveById(id) {
    penTool.manager.removeById(id);
  },
  // 关闭画笔工具
  pencilDeactive() {
    penTool.deactive();
  },
  /**
   * @description: 画笔
   * @param {pencilType} 画笔类型
   * @param {color} 画笔颜色
   * @param {size} 画笔尺寸
   * @param {isContinue} 连续
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  pencil2D(pencilType, color, lineWidth, fontSize, isContinue) {
    const ToolBase = Monge.PenType2D[pencilType];
    // penTool.deactive();
    return new Promise((reslove) => {
      penTool.active({
        type: ToolBase,
        color,
        lineWidth,
        fontSize,
        callback: (type) => {
          if (type === Monge.CallbackType.INPUT) {
            $prompt("请输入文本", "提示", { confirmButtonText: "确定", cancelButtonText: "取消" }).then(({ value }) => {
              setTimeout(() => { viewer2d.renderManager.needRender(); }, 10);
              penTool.setText(value);
              if (!isContinue) {
                penTool.deactive();
              }
              return reslove();
            }).catch(() => {
              Message.info("取消文本");
              if (!isContinue) {
                penTool.deactive();
              }
              return reslove();
            });
          } else if (type === Monge.CallbackType.DONE) {
            if (!isContinue) {
              penTool.deactive();
            }
            return reslove();
          }
        }
      });
    });
  },
  /**
   * @description: 画笔H5
   * @param {pencilType} 画笔类型
   * @param {color} 画笔颜色
   * @param {size} 画笔尺寸
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  pencilH52D(pencilType, color, lineWidth, fontSize, call) {
    const ToolBase = Monge.PenType2D[pencilType];
    penTool.active({
      type: ToolBase,
      color,
      lineWidth,
      fontSize,
      callback: (type, data) => {
        call.callback(type, data);
      }
    });
  },
  // 画笔设置字体内容
  pencilSetText(text) {
    penTool.setText(text);
  },
  // 画笔设置字体大小
  pencilSetFontSize(id, value) {
    penTool.manager.setFontSizeById(id, value);
  },
  // 画笔设置线宽
  pencilSetLineWidth(id, value) {
    penTool.manager.setLineWidthById(id, value);
  },
  // 画笔设置颜色
  pencilSetColor(id, value) {
    penTool.manager.setColorById(id, value);
  },
  // type:1 关闭当前图层 2：关闭其他图层
  mapMapToolAddSelectionEvent(type) {
    if (type === 1) {
      this.removeMapOtherSelectionEvent();
      selectMapTool.addSelectionEvent(this.selectAddSelectionEvent);
    } else if (type === 2) {
      this.removeAddSelectionEvent();
      selectMapTool.addSelectionEvent(this.selectMapOtherSelectionEvent);
    }
  },
  // 关闭当前图层
  selectAddSelectionEvent(data) {
    if (data && data.layerId) viewer2d.map.setLayerVisible(data.layerId, false);
  },
  // 移除关闭当前图层事件
  removeAddSelectionEvent() {
    selectMapTool.removeSelectionEvent(this.selectAddSelectionEvent);
  },
  // 关闭其他图层
  selectMapOtherSelectionEvent(data) {
    if (data && data.layerId) {
      viewer2d.map.hideOtherLayer(data.layerId);
      mongeMutations.hasCloseLayer();
    }
  },
  // 移除关闭其他图层事件
  removeMapOtherSelectionEvent() {
    selectMapTool.removeSelectionEvent(this.selectMapOtherSelectionEvent);
  },
  // 获取所有图层
  mapLayers() {
    const layers = Object.values(viewer2d.map.getLayers()).filter(({ name }) => name !== "__PLOT_POSITION_MARK_XS__");
    return layers;
  },
  // 控制图层显隐
  setVisibleById(id, isVisible) {
    viewer2d.map.setLayerVisible(id, isVisible);
  },
  // 图层全选或反选
  setAllVisible(boolean) {
    viewer2d.map.setAllLayerVisible(boolean);
  },
  // 图纸版本对比
  mapCompare(url) {
    viewer2d.disposeCompare();
    return new Promise((reslove) => {
      viewer2d.compare(
        url,
        () => { reslove(); },
        { isOssFile: this.isOssFile() }
      );
    });
  },
  // 取消图纸版本对比
  cancelMapCompare() {
    viewer2d.disposeCompare();
  },
  // 开始叠图
  async loadDrawing(url, color) {
    return viewer2d.load(url, {
      color: color,
      isPile: true,
      hideProgress: true,
      isOssFile: this.isOssFile()
    });
  },
  // 卸载叠图
  unloadDrawing(url) {
    const id = this.getMapId(url);
    if (id === undefined) {
      return;
    }
    viewer2d.unload(id);
  },
  // 获取叠图的id
  getMapId(url) {
    const maps = Object.values(viewer2d.maps);
    if (this.isOssFile()) {
      const obj = maps.find((e) => e.uri.fileId === url.fileId);
      return obj.id;
    } else {
      return maps.find((e) => e.uri === url).id;
    }
  },
  // 加载叠图后-平移
  mapMove(url) {
    const id = this.getMapId(url);
    if (id === undefined) return;
    panTool.active({ mapId: id });
  },
  // 加载叠图后-缩放
  mapScale(url) {
    const id = this.getMapId(url);
    if (id === undefined) return;
    scaleTool.active({ mapId: id });
  },
  // 加载叠图后-重置
  mapReset(url) {
    const id = this.getMapId(url);
    if (id === undefined) return;
    scaleTool.reset(id);
  },
  // 图纸添加云线
  async addAnnotation(color, call) {
    annotationManagerTool.clear();
    annotationTool.active({
      mode: Monge.AnnotationType.RECTANGLE,
      color: color || 0xff0000,
      callback: (type, data) => {
        if (type === Monge.CallbackType.ANNOTATION_ITEM_DONE) {
          call.callback(type);
        } else if (type === Monge.CallbackType.ANNOTATION_ALL_ITEM_DONE) {
          call.callback(type);
        } else if (type === Monge.CallbackType.DONE) {
          call.callback(type, data);
        }
      }
    });
  },
  // 停止矩形批注
  annotationEnd() {
    annotationTool.setAllItemDone();
  },
  setMapText(val) {
    annotationTool.setCurText(val);
  },
  // 清空云线锚点数据
  clearAnnotation() {
    mongeMutations.addMapList("");
    annotationManagerTool?.clear();
    markManagerTool?.clear();
  },
  // 关闭批注
  annotationDeactive() {
    annotationTool.deactive();
  },
  // 图纸截屏 设置为true时返回canvas，设置为false时返回dataUrl
  screenCaptureMap(boolean) {
    return new Promise((reslove) => {
      viewer2d.screenCapture(boolean, (canvas) => {
        reslove(canvas);
      });
    });
  },
  // 模型截屏 设置为true时返回canvas，设置为false时返回dataUrl
  screenCaptureModel(boolean) {
    return new Promise((reslove) => {
      viewer3d.screenCapture(boolean, (canvas) => {
        reslove(canvas);
      });
    });
  },
  // 模型图纸截屏
  screenCaptureModelMap(boolean) {
    return new Promise((reslove) => {
      Monge.MultiScene.printScreen2DAnd3D({
        viewer2d,
        viewer3d,
        callback: (canvas) => {
          if (boolean) reslove(canvas);
          else reslove(canvas.toDataURL());
        }
      });
    });
  },
  // 展示云线
  annoShow(id, data, color) {
    data.stMarkNewInfo.color = color;
    annotationManagerTool.add({
      data,
      callback: (type, val) => {
        if (type === Monge.CallbackType.DONE) {
          // 云线完成
          const obj = { id: val.id, questionId: id };
          mongeMutations.addMapList(obj);
        }
      }
    });
    if (data.stAddMarkInfos) {
      for (let i = 0; i < data.stAddMarkInfos.length; i++) {
        const e = data.stAddMarkInfos[i];
        const data2 = { ...e };
        data2.stMarkNewInfo = data2.stMergeMarkInfo;
        data2.stMarkNewInfo.color = color;
        data2.stMarkNewInfo.m_nClouadType = data2.stMarkNewInfo.m_nCloudType;
        annotationManagerTool.add({
          data: data2,
          callback: (type, val) => {
            if (type === Monge.CallbackType.DONE) {
              const obj = { id: val.id, questionId: id };
              mongeMutations.addMapList(obj);
            }
          }
        });
      }
    }
  },
  // 定位单个云线
  mapAim(id, item, color) {
    const { innerHeight, innerWidth } = window;
    mongeMutations.addMapList("");
    annotationManagerTool.clear();
    const data = { id, ...item };
    data.stMarkNewInfo.color = color;
    const ids = [];
    const promises = [];
    const promise = new Promise((res) => {
      annotationManagerTool.add({
        data,
        callback: (type, val) => {
          if (type === Monge.CallbackType.DONE) {
            const obj = { id: val.id, questionId: id };
            mongeMutations.addMapList(obj);
            ids.push(val.id);
            res();
          }
        }
      });
    });
    promises.push(promise);
    if (item.stAddMarkInfos) {
      for (let i = 0; i < item.stAddMarkInfos.length; i++) {
        const e = item.stAddMarkInfos[i];
        const data2 = { id, ...e };
        data2.stMarkNewInfo = data2.stMergeMarkInfo;
        data2.stMarkNewInfo.color = color;
        data2.stMarkNewInfo.m_nClouadType = data2.stMarkNewInfo.m_nCloudType;
        const promiseItem = new Promise((res) => {
          annotationManagerTool.add({
            data: data2,
            callback: (type, val) => {
              if (type === Monge.CallbackType.DONE) {
                const obj = { id: val.id, questionId: id };
                mongeMutations.addMapList(obj);
                ids.push(val.id);
                res();
              }
            }
          });
        });
        promises.push(promiseItem);
      }
    }
    Promise.all(promises).then(() => {
      const width =  innerWidth- 300 - 360 // 视口宽度 - 列表 -详情
      annotationManagerTool.fitToAnnotations({
        ids,
        range: {
          offset: {
            x: 0,
            y: 0,
          },
          size: {
            x: width,
            y: innerHeight,
          },
        },
        duration: 500
      });
    });
  },
  // 模型框选放大
  zoom3D(switchBoolean) {
    return new Promise((reslove) => {
      zoomTool.active({
        continuous: false,
        callback: (type) => {
          if (type === Monge.CallbackType.DONE) reslove(!switchBoolean);
        }
      });
    });
  },
  // 模型清除测量
  clearMeasure() {
    measureManagerTool.clear();
  },
  // 模型关闭测量
  deactiveMeasure() {
    measureTool.deactive();
  },
  /**
   * @description: 模型测量
   * @param {ToolBase} 测量类型
   * @param {unit} 测量单位
   * @param {continuous} 是否连续测量
   * @param {enableSnapper} 设置捕捉功能开启和关闭
   * @param {switchBoolean} 回调
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  measure3D(ToolBase, unit, continuous, enableSnapper, switchBoolean) {
    measureTool.unit = unit || Monge.Unit.MM;
    return new Promise((reslove) => {
      measureTool.active({
        mode: ToolBase,
        continuous,
        enableSnapper,
        callback: (type) => {
          if (type === Monge.CallbackType.DONE) reslove(!switchBoolean);
        }
      });
    });
  },
  /**
   * @description: 模型测量H5
   * @param {ToolBase} 测量类型
   * @param {unit} 测量单位
   * @param {continuous} 是否连续测量
   * @param {enableSnapper} 设置捕捉功能开启和关闭
   * @param {call} 回调
   * @return 没有返回信息写 void / 有返回信息 {返回类型} 描述信息
   */
  measureH53D(ToolBase, call) {
    measureTool.unit = Monge.Unit.MM;
    measureTool.active({
      mode: ToolBase,
      continuous: false,
      enableSnapper: false,
      callback: (type) => {
        call.callback(type);
      }
    });
  },
  /**
   * @description: 模型剖切
   * @param {ToolBase} 剖切类型
   * @param {showSectionPlane} 是否显示剖切平面
   * @param {showSectionHandle} 是否显示剖切把手
   * @param {showSectionFill} 是否显示填充面
   */
  section3D(ToolBase, showSectionPlane, showSectionHandle, showSectionFill) {
    if (ToolBase === "art") {
      sectionTool.sectionBySelection();
    } else {
      sectionTool.active({
        mode: ToolBase,
        showSectionPlane,
        showSectionHandle,
        showSectionFill
      });
    }
  },
  // 构件剖切
  sectionArt3D() {
    sectionTool.sectionBySelection();
  },
  // 取消剖切
  deactiveSection() {
    sectionTool.deactive();
  },
  // 获得剖切模式
  getSectionMode() {
    const actived = sectionTool && sectionTool.actived;
    if (!actived) return "";
    return sectionTool.mode;
  },
  // 获得剖切位置
  getSectionPos(type) {
    return sectionTool.getSectionPos(type);
  },
  // 设置剖切位置
  setSectionPos(mode, position) {
    const boxMode = mode === "box";
    sectionTool.active({
      mode,
      plane: boxMode ? undefined : position,
      box: boxMode ? position : undefined
    });
  },
  // 模型版本比对
  modelCompare(url) {
    viewer3d.disposeCompare();
    const isOssFile = this.isOssFile();
    return new Promise((reslove) => {
      viewer3d.compare(
        url,
        () => { reslove(); },
        isOssFile
      );
    });
  },
  // 强制刷新
  needUpdate() {
    viewer3d.renderManager.needUpdate(true, true, true);
  },
  // 取消模型版本对比
  cancelModelCompare() {
    viewer3d.disposeCompare();
  },
  // 是否选中构件
  selectCheck() {
    return selectTool && selectTool.getSelection().length > 0;
  },
  // 设置构件颜色
  setElementColor(color) {
    if (!this.selectCheck()) Message.info("请先选择构件");
    const selectList = selectTool.getSelection() || [];
    selectList.forEach((e) => {
      const model = viewer3d.getModel(e.modelId);
      model.setElementColor(e.elementId, color);
    });
  },
  // 重置构件所有颜色
  resetElementColor() {
    const allModelList = viewer3d.models || [];
    allModelList.forEach((model) => {
      model.resetAllElementColor();
    });
  },
  // 获取模型所有标高
  getLevels() {
    return viewer3d.getLevels();
  },
  // 小地图
  changeMini(val, showName, call) {
    miniMapTool.active({
      mapWidth: 400,
      mapHeight: 300,
      enlargeSize: 2,
      showName,
      tools: {
        zoom: true,
        close: false
      },
      height: val,
      enlargeCB: () => {
        // 窗口放大
        // call.callback(1)
      },
      shrinkCB: () => {
        // 窗口缩小
        // call.callback(2)
      },
      deactiveCB: () => {
        // 关闭
        call.callback(3);
      }
    });
  },
  // 小地图H5
  changeMiniH5(val, showName, call) {
    miniMapTool.active({
      mapWidth: 200,
      mapHeight: 150,
      enlargeSize: 2,
      location: "top",
      showName,
      tools: {
        zoom: false,
        close: true
      },
      height: val,
      enlargeCB: () => {
        // 窗口放大
        // call.callback(1)
      },
      shrinkCB: () => {
        // 窗口缩小
        // call.callback(2)
      },
      deactiveCB: () => {
        // 关闭
        call.callback(3);
      }
    });
  },
  // 取消小地图
  miniDective() {
    miniMapTool.deactive();
  },
  // 设置小地图高度
  setMiniHeight(val) {
    miniMapTool.setHeight(val);
  },
  // 小地图显示房间
  setNameShow(flag) {
    miniMapTool.setNameShow(flag);
  },
  showSpaceName(params) {
    space3DTool.showSpaceName(params);
  },
  // 设置模型背景色 颜色为 RGB的数组
  set3DBgc(value) {
    viewer3d.renderManager.setBackground(value[0], value[1], value[2]);
  },
  get3DBgc() {
    return viewer3d.renderManager.getBackground();
  },
  // 天空盒
  setSkyBox() {
    viewer3d.renderManager.setBackground(-1);
  },
  // 交互配置项
  walkOption3D() {
    return {
      gravity: walkTool.getGravity(), // 重力
      collide: walkTool.getCollide(), // 碰撞
      fixedZAxis: walkTool.fixedZAxis, // z轴锁定
      speed: walkTool.getSpeed(), // 漫游移动速度
      zoomSpeed: viewer3d.navigation.zoomSpeed, // 鼠标缩放速度
      focusModelRotateSpeed: viewer3d.navigation.focusModelRotateSpeed, // 绕模型旋转速度
      focusModel: viewer3d.navigation.focusModel, // 绕模型旋转
      hoverEnable: viewer3d.selector.hoverEnable, // 悬停效果
      selectionFlash: viewer3d.selector.selectionFlash // 选择后呼吸效果
    };
  },
  // 效果配置项
  contour() {
    const effect = viewer3d.effect;
    return {
      fouLine: Boolean(effect & Monge.EffectType3D.FouLine),
      fxaa: Boolean(effect & Monge.EffectType3D.FXAA),
      ssao: Boolean(effect & Monge.EffectType3D.SSAO), // 环境光遮蔽
      shadow: Boolean(effect & Monge.EffectType3D.Shadow), // 阴影
      automaticExposure: Boolean(effect & Monge.EffectType3D.AutomaticExposure) // 曝光自适应
    };
  },
  environment() {
    return {
      mode: viewer3d.getEnvironmentMode(),
      weather: viewer3d.weatherManager.type,
      weatherIntensity: Monge.WeatherIntensity.SMALL
    };
  },
  changeBgc(val) {
    viewer3d.setEnvironmentMode(val);
  },
  // 天气
  weatherType() {
    return [
      { showName: "晴天", value: Monge.WeatherType.SUNNY },
      { showName: "雨天", value: Monge.WeatherType.RAINY },
      { showName: "雪天", value: Monge.WeatherType.SNOWY }
    ];
  },
  weatherIntensityList() {
    return [
      { value: Monge.WeatherIntensity.SMALL, showName: "小" },
      { value: Monge.WeatherIntensity.MEDIUM, showName: "中" },
      { value: Monge.WeatherIntensity.LARGE, showName: "大" }
    ];
  },
  getweatherIntensity() {
    return Monge.WeatherIntensity.SMALL;
  },
  changeWeather(val) {
    viewer3d.weatherManager.type = val;
  },
  changeWeatherIntensity(val) {
    viewer3d.weatherManager.intensity = val;
  },
  selector() {
    return {
      hoverEnable: viewer3d.selector.hoverEnable, // 悬停效果
      selectionFlash: viewer3d.selector.selectionFlash // 选择后呼吸效果
    };
  },
  // 渲染效果配置项
  effectOption3D() {
    // const effect = viewer3d.effect;
    return {
      // fouLine: Boolean(effect & Monge.EffectType3D.FouLine), // 模型边线
      // ssao: Boolean(effect & Monge.EffectType3D.SSAO), // 环境光遮蔽
      // shadow: Boolean(effect & Monge.EffectType3D.Shadow), // 阴影
      // automaticExposure: Boolean(effect & Monge.EffectType3D.AutomaticExposure), // 曝光自适应
      intensity: viewer3d.lightManager.getLightIntensity(), // 亮度
      saturation: viewer3d.renderManager.getSaturation(), // 饱和度
      temperature: viewer3d.lightManager.getLightTemperature() // 色温
      // time: viewer3d.getSunTime()
    };
  },
  // 漫游速度
  changeSpeed(value) {
    walkTool.setSpeed(value);
  },
  // 旋转速度
  changeRotateSpeed(value) {
    walkTool.setRotateSpeed(value);
  },
  // 固定Z轴
  changefixedZAxis(value) {
    walkTool.fixedZAxis = value;
  },
  // 绕模型旋转速度
  changeFocusModelRotateSpeed(val) {
    viewer3d.navigation.focusModelRotateSpeed = val;
  },
  // 绕模型旋转
  changeFocusModel(val) {
    viewer3d.navigation.focusModel = val;
  },
  // 鼠标悬停效果
  changeHoverEnable(val) {
    viewer3d.selector.hoverEnable = val;
  },
  // 选择呼吸效果
  changeSelectionFlash(val) {
    viewer3d.selector.selectionFlash = val;
  },
  changeZoomSpeed(val) {
    viewer3d.navigation.zoomSpeed = val;
  },
  // 碰撞检测
  changeCollide(value) {
    walkTool.setCollide(value);
  },
  // 重力
  changeGravity(value) {
    walkTool.setGravity(value);
  },

  // 模型边线
  changeFouLine(value) {
    viewer3d.fouLine(value);
  },
  changeFxaa(value) {
    viewer3d.FXAA(value);
  },
  // 环境光遮蔽
  changeSsao(value) {
    viewer3d.SSAO(value);
  },
  // 阴影
  changeShadow(value) {
    viewer3d.optionManager.shadow(value);
  },
  // 曝光自适应
  changeAutomaticExposure(value) {
    viewer3d.optionManager.enableAutomaticExposure(value);
  },
  // 亮度
  changeIntensity(value) {
    viewer3d.lightManager.setLightIntensity(value);
  },
  // 饱和度
  changeSaturation(value) {
    viewer3d.renderManager.setSaturation(value);
  },
  // 色温列表
  curTemperatureList() {
    return [
      { name: "冷色", value: Monge.ColorTemperatureType.COLD },
      { name: "正常", value: Monge.ColorTemperatureType.NORMAL },
      { name: "暖色", value: Monge.ColorTemperatureType.WARM }
    ];
  },
  getBgcList() {
    return [
      { value: Monge.EnvironmentMode.DEFAULT, label: "默认" },
      { value: Monge.EnvironmentMode.NIGHT, label: "夜晚" },
      { value: Monge.EnvironmentMode.CLOUDY, label: "阴天" },
      { value: Monge.EnvironmentMode.DUSK, label: "黄昏" },
      { value: Monge.EnvironmentMode.PURE_COLOR, label: "纯色" }
    ];
  },
  // 色温
  changeTemperature(value) {
    viewer3d.lightManager.setLightTemperature(value);
  },
  // 天空盒时间
  changeTime(val) {
    viewer3d.setSunTime(val);
  },
  // 三维地球
  globeLocation() {
    globeTool.active();
    globeTool.provider.fetchTile = (zoom, x, y) => {
      return new Promise((resolve, reject) => {
        const image = document.createElement("img");
        image.onload = function () {
          resolve(image);
        };
        image.onerror = function () {
          reject();
        };

        image.crossOrigin = "Anonymous";
        image.src = `https://server.arcgisonline.com/ArcGIs/rest/services/World_Imagery/Mapserver/tile/${zoom}/${y}/${x}`;
      });
    };
    const height = (viewer3d._modelsStuffBoundingBox.max.z - viewer3d._modelsStuffBoundingBox.min.z) * 0.5;
    const position = globeTool.getWorldPositionByCarto([117.1678073, 36.651503, height]);
    const transfrom = new Monge.Matrix4();
    // 平移
    const translationMatrix = new Monge.Matrix4();
    translationMatrix.setPosition(position);
    transfrom.premultiply(translationMatrix);
    viewer3d.models.forEach((model) => {
      model.setMatrix(transfrom);
    });

    viewer3d.cameraManager.fit2Box(viewer3d._modelsStuffBoundingBox, 0);
  },
  // 创建模型锚点
  addMark3D(color, call) {
    markManagerTool?.clear();
    markTool.active({
      color: color || 0xff0000,
      callback: (type, data) => {
        if (Monge.CallbackType.DONE === type) {
          const val = { ...data, modelUrl: [], dom: "" };
          call.callback(val);
        }
      }
    });
  },
  // 获取模型相机位置
  getViewport() {
    return new Promise((resolve) => {
      resolve(viewer3d?.cameraManager?.getViewport());
    });
  },
  // 模型定位
  async modelAim(id, data, viewportData, fileName, callback) {
    const isNoLightweight = mongeApp.model.isNoLightweight;
    if (!isNoLightweight) {
      const modelId = viewer3d.models.find(e => e.url?.bimexName === fileName)?.id;
      const revitId = data.elementId;
      mongeMutations.addMapList("");
      annotationManagerTool?.clear();
      markManagerTool?.clear();
      // 引擎人员推荐写法
      const result = viewer3d.getElementIdsByAttribute("#elementId", revitId);
      if (viewportData) {
        viewportData && viewer3d.cameraManager.setViewport(JSON.parse(viewportData), callback);
      } else if (result && Array.isArray(result[modelId]) && result[modelId][0]) {
        const elementId = result[modelId][0];
        viewer3d.cameraManager.fit2Element(modelId, elementId);
      }
      this.showMark(id, data);
    } else {
      mongeMutations.addMapList("");
      annotationManagerTool?.clear();
      markManagerTool?.clear();
      this.showMark(id, data);
      viewportData && viewer3d.cameraManager.setViewport(JSON.parse(viewportData), callback);
    }
  },
  // showNewMark(modelId, revitId) {
  //   const result = viewer3d.getElementIdsByAttribute("#elementId", revitId);
  //   if (result && Array.isArray(result[modelId]) && result[modelId][0]) {
  //     const elementId = result[modelId][0];
  //     viewer3d.cameraManager.fit2Element(modelId, elementId);
  //   }
  // },
  // 展示锚点
  showMark(id, data) {
    markTool.addMark(data, (type, val) => {
      if (type === Monge.CallbackType.DONE) {
        const obj = { id: val.id, questionId: id };
        mongeMutations.addMapList(obj);
      }
    });
  },
  // 模型复位
  modelFitToAll() {
    viewer3d.cameraManager.goHome();
  },
  // 获取模型数据
  getModels() {
    return viewer3d.models.map((model) => {
      const rootNodeId = model.attrManager.rootId;
      const modelName = model.attrManager.getItemName(rootNodeId);
      return {
        ...model,
        cnName: modelName
      };
    });
  },
  // 同步模型树
  getTreeData() {
    const models = viewer3d.models;
    const tree = [];
    models.forEach(async (model) => {
      const rootNodeId = model.attrManager.rootId;
      const modelName = model.attrManager.getItemName(rootNodeId);
      const mgNodeId = this.getTreeNodeId(model.id, rootNodeId);
      mongeMutations.addshowElementIdlist(mgNodeId);
      const list = {
        mgNodeId,
        label: modelName,
        modelId: model.id,
        elementId: rootNodeId,
        children: await this.getNextData(model.id, rootNodeId)
      };
      tree.push(list);
    });
    return tree;
  },
  getNextData(modelId, elementId) {
    const model = viewer3d.getModel(modelId);
    const list = model.attrManager.getSubItems(elementId);
    const levelMore = [];
    list?.forEach(async (childId) => {
      const name = model.attrManager.getItemName(childId);
      const nodeChildren = model.attrManager.getSubItems(childId);
      const mgNodeId = this.getTreeNodeId(modelId, childId); // 每一个node的key
      mongeMutations.addshowElementIdlist(mgNodeId);
      levelMore.push({
        mgNodeId,
        label: name,
        modelId: modelId,
        elementId: childId,
        children: nodeChildren.length > 0 && (await this.getNextData(modelId, childId))
      });
    });
    return levelMore;
  },
  // 模型树-异步
  loadTreeData(node) {
    const models = viewer3d.models;
    if (node.level === 0) {
      const levelOne = [];
      models.forEach((model) => {
        const rootNodeId = model.attrManager.rootId;
        const modelName = model.attrManager.getItemName(rootNodeId);
        const list = {
          mgNodeId: this.getTreeNodeId(model.id, rootNodeId),
          label: modelName,
          modelId: model.id,
          elementId: rootNodeId,
          children: []
        };
        levelOne.push(list);
      });
      return levelOne;
    } else if (node.level > 0) {
      return this.loadNextData(node);
    }
  },
  loadNextData(node) {
    const modelId = node.data.modelId;
    const elementId = node.data.elementId;
    const model = viewer3d.getModel(modelId);
    const list = model.attrManager.getSubItems(elementId);
    const levelMore = [];
    list?.forEach((childId) => {
      const name = model.attrManager.getItemName(childId);
      const nodeChildren = model.attrManager.getSubItems(childId);
      levelMore.push({
        mgNodeId: this.getTreeNodeId(modelId, childId), // 每一个node的key
        label: name,
        modelId: modelId,
        elementId: childId,
        isLeaf: nodeChildren.length === 0
      });
    });
    return levelMore;
  },
  // 构件隐藏
  elementIdHide(modelId, elementId) {
    viewer3d.hide(modelId, elementId);
  },
  // 构件显示
  elementIdShow(modelId, elementId) {
    viewer3d.show(modelId, elementId);
  },
  elementShowAll() {
    viewer3d.showAll();
  },
  elementIsHide(modelId, elementId) {
    return viewer3d.elementIsHide(modelId, elementId);
  },
  // 高亮定位
  selectPick(data) {
    const modelId = data.modelId;
    const elementId = data.elementId;
    // 取消之前选择
    selectTool.cancelSelect();
    // 选择
    selectTool.pick(modelId, elementId);
    // 定位
    selectTool.fitTo();
  },
  // 取消之前选择
  cancelSelectPick() {
    selectTool.cancelSelect();
    viewer3d.cameraManager.goHome();
  },
  // 房间列表
  spaceView(levelId) {
    const treeData = [];
    // 获取楼层信息
    const levelInfo = this.getLevels().find((level) => level.id === levelId);
    if (!levelInfo) return;
    // 删除已经创建的面积平面
    viewer3d.spaceManager.clear();
    // 楼层标高
    const elevation = levelInfo.elevation;
    sectionTool.active({
      mode: "z",
      height: elevation + 5,
      showSectionHandle: false
    });
    // 面积平面数据
    const areaData = viewer3d.spaceManager.data;
    console.log("areaData", areaData);
    areaData.forEach((area) => {
      const revitId = area.ElementID;
      const name = area.Name;
      if (area.LevelID === levelId) {
        treeData.push({
          label: name,
          revitId
        });
        viewer3d.spaceManager.create(area, {
          text: area.Name
        });
      }
    });
    return treeData || [];
  },
  // 点击房间名称
  selectOnlyOneById(revitId) {
    viewer3d.spaceManager.selectOnlyOneById(revitId);
    const params = {
      id: revitId,
      duration: 700
    };
    viewer3d.spaceManager.fitTo(params);
  },
  // 框选房间
  selectByRect() {
    areaPlaneTool.active({
      selectColor: 0x2194ce
    });
  },
  // 模型系统
  loadSysData() {
    const array = [];
    const models = viewer3d.models;
    models.forEach((model) => {
      const modelId = model.id;
      const rootNodeId = model.attrManager.rootId;
      const modelName = model.attrManager.getItemName(rootNodeId);
      const treeSystemTypeNode = {
        label: modelName,
        mgNodeId: this.getTreeNodeId(model.id, rootNodeId),
        children: []
      };
      model.elementIterator(rootNodeId, (elementId) => {
        const property = model.attrManager.getItemAttributes(elementId);
        const systemTypeProp = property.find((p) => p.group === "机械" && p.name === "系统分类");
        const nameProp = property.find((p) => p.name === "#name");
        if (systemTypeProp && nameProp) {
          const systemTypeNode = treeSystemTypeNode.children.find((n) => n.label === systemTypeProp.value);
          if (systemTypeNode) {
            // 系统类别层级
            systemTypeNode.children.push({
              label: nameProp.value,
              mgNodeId: this.getTreeNodeId(model.id, elementId),
              elementId,
              modelId: modelId
            });
          } else {
            // 系统类别层级
            treeSystemTypeNode.children.push({
              label: systemTypeProp.value,
              mgNodeId: this.getTreeNodeId(model.id, elementId),
              children: [
                {
                  label: nameProp.value,
                  mgNodeId: this.getTreeNodeId(model.id, nameProp.value),
                  elementId,
                  modelId: modelId
                }
              ]
            });
          }
        }
      });
      array.push(treeSystemTypeNode);
    });
    return array;
  },
  // 模型属性
  loadAttribute(tree) {
    if (!tree) return [];
    let modelAttrData = [];
    const treedata = [];
    let arr = "";
    let children = [];
    for (let i = 0; i < tree.length; i++) {
      const str = tree[i].name + "：" + tree[i].value;
      const child = { label: str };
      if (tree[i].group === arr) {
        children.push(child);
        if (tree.length - 1 === i) {
          treedata.push({
            label: arr,
            children: children.concat([])
          });
        }
      } else {
        if (i === 0) {
          arr = tree[i].group;
          children.push(child);
        } else {
          treedata.push({
            label: arr,
            children: children.concat([])
          });
          children = [];
          arr = tree[i].group;
          children.push(child);
        }
      }
    }
    modelAttrData = treedata.slice(2);
    if (treedata.length > 0) {
      for (let i = 0; i < modelAttrData.length; i++) {
        if (modelAttrData[i].label === "其他") {
          modelAttrData[i].label = "基本信息";
          const a = modelAttrData[0];
          modelAttrData[0] = modelAttrData[i];
          modelAttrData[i] = a;
          break;
        }
      }
    }
    return modelAttrData;
  },
  getAttrTree() {
    const model = viewer3d.models.find((m) => m.id === mongeApp.model.modelId);
    if (!model) return [];
    const property = model.attrManager.getItemAttributes(mongeApp.model.elementId);
    return this.loadAttribute(property);
  },
  /**
   * @description: 二三维叠图使用
   * @param {val} 剖切位置
   */
  setSection(val) {
    sectionTool.setSectionPos("z", val);
  },
  // 模型上叠加图纸
  async startModelOverlay(url) {
    sectionTool.active({
      height: url.sliderLocation,
      showSectionPlane: false,
      showSectionFill: false,
      showSectionHandle: false
    });
    const isOssFile = this.isOssFile();
    // 在三维中加载二维图纸
    return await viewer3d.loadDrawing({ url, distance: url.sliderLocation, isOssFile });
  },
  // 与剖切工具进行绑定
  startDrawing(drawing) {
    sectionTool.bindDrawing(drawing);
  },
  // 模型上卸载图纸
  unloadModelDrawing(drawing) {
    viewer3d.unloadDrawing(drawing);
  },
  getbboxmax() {
    return viewer3d.boundingBox.max;
  },
  getbboxmin() {
    return viewer3d.boundingBox.min;
  },
  // 图纸对齐工具
  transformMap(drawing) {
    transformTool.active({
      object: drawing,
      // 调整方向
      enabledAxis: [Monge.AxisType.X, Monge.AxisType.Y],
      // 变换类型
      transformType: Monge.TransformType.PAN
    });
  },
  // 关闭图纸对齐工具
  stopTransformMap() {
    transformTool.deactive();
  },
  // 路径漫游添加帧
  addFrame(call) {
    viewer3d.screenCapture(false, (dataUrl) => {
      const viewport = viewer3d.cameraManager.getViewport();
      call.callback({ viewport, dataUrl, duration: 1 });
    });
  },
  // 开始漫游
  startRoaming(path, call) {
    viewer3d.cameraManager.startRoam({
      path,
      callback: (type) => {
        if (type === Monge.CallbackType.DONE) {
          call.callback("done");
        }
      }
    });
  },
  // 停止漫游
  stopRoaming() {
    viewer3d.cameraManager.stopRoam();
  },
  setViewport(viewport) {
    viewer3d.cameraManager.setViewport(viewport);
  },
  // 模型碰撞时用到(一个模型的数据树)
  loadOneModelData(node, modelId) {
    if (node.level === 0) {
      const model = viewer3d.getModel(modelId);
      const rootNodeId = model.attrManager.rootId;
      const modelName = model.attrManager.getItemName(rootNodeId);
      const list = [
        {
          mgNodeId: this.getTreeNodeId(model.id, rootNodeId),
          label: modelName,
          modelId: model.id,
          elementId: rootNodeId,
          children: []
        }
      ];
      return list;
    } else if (node.level > 0) {
      return this.loadNextData(node);
    }
  },
  // 碰撞
  startCalculate(collisionType, softDis, data, call) {
    const callback = (per) => { call.callback(per * 100); };
    viewer3d.collision.distance.setUpperBound(softDis);
    viewer3d.collision.detect({
      mode: collisionType,
      ...data,
      callback
    });
  },
  // 碰撞数据
  getCollisionData(start, count) {
    const params = {
      data: viewer3d.collision.getResult((start - 1) * count, count),
      totalCount: viewer3d.collision.getResultCount()
    };
    return params;
  },
  // 定位到构件
  fitToInsert(id) {
    viewer3d.collision.display(id);
    viewer3d.collision.fitToInsert(id);
  },
  // 导出
  exportExcel() {
    const option = {};
    const resultCount = viewer3d.collision.getResultCount();
    const result = viewer3d.collision.getResult(0, resultCount);
    option.fileName = "碰撞检测结果";
    option.datas = [
      {
        sheetData: result,
        sheetName: "碰撞检测结果",
        sheetFilter: ["element1Name", "element2Name", "distance"],
        sheetHeader: ["构件1", "构件2", "距离"],
        columnWidths: [10, 10]
      }
    ];
    const toExcel = new ExportJsonExcel(option); // new
    toExcel.saveExcel(); // 保存
  },
  // 开启虚拟摇杆
  JoyStickerActive() {
    JoyStickTool.active();
  },
  // 开始行走
  JoyStickerStart() {
    JoyStickTool.startWalk();
  },
  // 行走
  JoyStickerWalk(force, angle) {
    JoyStickTool.walk(force, angle);
  },
  // 停止行走
  JoyStickerEndWalk() {
    JoyStickTool.endWalk();
  },
  joyStickmoveUp(boolean) {
    JoyStickTool.moveUp(boolean);
  },
  joyStickmoveDown(boolean) {
    JoyStickTool.moveDown(boolean);
  },

  getTreeNodeId(modelId, elementId) {
    return `${modelId}_${elementId}`;
  },

  // 关闭框选放大
  closeAmplifications() {
    zoomTool2D.actived && zoomTool2D?.deactive();
    zoomTool.actived && zoomTool?.deactive();
  },
  // 关闭测量
  closeMeasure() {
    measureTool2D.actived && measureTool2D.deactive();
  },
  // 关闭画笔
  closePencil() {
    penTool.actived && penTool.deactive();
    penTool.manager.clear();
  },
  // 关闭叠图
  closeOverlay() {
    const maps = Object.values(viewer2d?.maps);
    maps.forEach((item) => {
      // loadType：3主图，4叠图，5对比加载的图纸
      if (item.loadType === 4) viewer2d.unload(item.id);
    });
    mongeMutations.setOverlayList();
  },
  // 关闭批注
  closeIssue() {
    annotationTool?.deactive();
    annotationManagerTool?.clear();
    markManagerTool?.clear();
    markTool?.deactive();
  },
  // 关闭批注列表
  closeList() {
    mongeMutations.setHasList(false);
    mongeMutations.addMapList("");
    annotationManagerTool?.clear();
    markManagerTool?.clear();
  },
  // 关闭批注详情
  closeDetail() {
    mongeMutations.setQuestionId();
  },
  // 关闭小地图
  closeModelMini() {
    miniMapTool.actived && miniMapTool.deactive();
  },
  // 关闭模型测量
  closeModelMeaure() {
    measureTool.actived && measureTool.deactive();
  },
  // 关闭剖切
  closeSection() {
    sectionTool.actived && sectionTool.deactive();
  },
  // 关闭地图
  closeGlobe() {
    viewer3d.models.forEach((model) => {
      model.resetMatrix();
    });
    globeTool.actived && globeTool.deactive();
  },
  // 关闭版本比对
  closeComparison() {
    viewer2d?.disposeCompare();
    viewer3d?.disposeCompare();
    mongeMutations.openLegend(false);
  },
  // 关闭二三维叠图
  closeModelOverlay() {
    sectionTool.actived && sectionTool.deactive();
    transformTool.deactive();
  },
  // 关闭二三维叠图工具
  closeModelOverlayTool() {
    transformTool.deactive();
  },
  // 关闭模型空间
  closeAreaPlane() {
    areaPlaneTool.actived && areaPlaneTool.deactive();
    sectionTool.actived && sectionTool.deactive();
    viewer3d.spaceManager.clear();
  },
  // 关闭模型剖切H5
  closeModelSectionH5() {
    sectionTool.deactive();
  },
  // 关闭模型树(H5使用)
  closeModelTree() {
    mongeMutations.changeShowApp(true);
  },
  // 关闭模型属性(H5使用)
  closeModelAttr() {
    mongeMutations.changeShowApp(true);
  }

};
export default enginerelease;
